import { Modal } from '../..';
import { ReactComponent as OptInSvg } from '../../../images/role-opt-in-icon.svg';
import { Role } from '../../../../types';
import BEM from '../../../bem';

const classes = BEM.with('GeneralRoleModal');

type AssignedRoleModalProps = {
  closeModal: () => void;
  isOpen: boolean;
  options: {
    event: {
      role: Role;
    };
  };
};
const AssignedRoleModal = ({ isOpen, options, closeModal }: AssignedRoleModalProps) => {
  const _requestClose = () => {
    closeModal();
  };

  const imgHeader = {
    image: OptInSvg,
    imgClassHeader: classes('img'),
  };

  return (
    <Modal
      bodyClass={classes('body')}
      className={classes()}
      header={"You've been opted into a role"}
      headerClass={classes('header')}
      imgHeader={imgHeader}
      isOpen={isOpen}
      onRequestClose={_requestClose}
      size={'medium'}
      footerPrimaryActions={
        <button type="button" className={classes('submit-btn')} onClick={_requestClose}>
          GOT IT
        </button>
      }
    >
      <div className={classes('body-container')}>
        <div className={classes('row')}>
          {"You're now on duty for"}
          <div className={classes('display-name')}>{` ${options.event.role.displayName}, `}</div>
        </div>
        <div className={classes('row')}>{'designated by the administrator.'}</div>
      </div>
    </Modal>
  );
};

export default AssignedRoleModal;
